// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.helixid",
    name: "helix id",
    homepage: "https://helixid.io/",
    image_id: "4083ef71-8389-4682-ded6-0099236d2e00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/de/app/helix-id/id1469238013?l=en",
        android: "https://play.google.com/store/apps/details?id=com.io.helix.id&hl=en&gl=US",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "helix-id://helix-id.com",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map